import { getLineGroupTags } from "@/lib/businessLogic";
import { LINE_GROUP_TAGS_ACCESS } from "@/lib/ManufacturingTags.generated";
import { DAYS_IN_WEEK } from "@/lib/constants";

export const getMaxDaysForHorizon = (line_group_uuid: string, horizon: string): number => {
    if (!line_group_uuid || !horizon) return DAYS_IN_WEEK;

    const tags = getLineGroupTags(line_group_uuid);

    return (
        {
            shift: LINE_GROUP_TAGS_ACCESS.stock_forecast_display_horizon_shift(tags),
            day: LINE_GROUP_TAGS_ACCESS.stock_forecast_display_horizon_day(tags),
            week: LINE_GROUP_TAGS_ACCESS.stock_forecast_display_horizon_week(tags),
        }[horizon] ?? DAYS_IN_WEEK
    );
};
